"use strict";

exports.__esModule = true;
exports.EXTERNAL_NAME = void 0;
var EXTERNAL_NAME = 'MwVisualizationsV8';
exports.EXTERNAL_NAME = EXTERNAL_NAME;